@import './pk-tabs.variables';

.pk-tabs__tab-bar {
  @apply flex w-full overflow-hidden whitespace-nowrap border-0 border-b-[1px] border-solid border-b-[color:--tabs--border-color];

  &--right {
    @apply justify-end;
  }

  &--center {
    @apply justify-center;
  }

  &--stretch {
    .pk-tabs__tabs-container {
      @apply w-full;

      &::slotted(pk-tab) {
        @apply flex-grow;
      }
    }
  }
}

.pk-tabs__tabs-container {
  @apply flex overflow-x-auto;

  &::-webkit-scrollbar {
    @apply hidden;
  }
}

.pk-tabs__more-button {
  @apply hidden select-none border-0 border-l-[1px] border-solid border-l-[color:--tabs--border-color];

  &.visible {
    @apply inline-block;
  }
}

::slotted([slot='more']) {
  pk-menu {
    @apply [--menu--background-color:--pk-background] [--menu--padding-bottom:0] [--menu--padding-top:0];
  }

  &::part(menu) {
    @apply w-full;
  }

  button {
    @include transition(#{color, background-color});

    @apply button-reset relative flex min-h-[40px] items-center pb-[7px] pl-s pr-s pt-[9px] text-[length:--tabs--font-size] leading-s text-interaction;

    font-family: var(--tabs--font-family);

    // We add a hidden content to the more button
    // in order to keep alignment consistences within the tabs button
    &::after {
      @apply invisible absolute bottom-0 left-0 h-[3px] w-full content-[''];
    }

    &:hover {
      @apply text-[color:--tab--color-active];
    }

    &:active {
      @apply text-[color:--tab--color-active];
    }

    &:focus {
      @apply bg-[color:--tab--bg-focus];
    }
  }
}
